import hljs from 'highlight.js';
import 'highlight.js/scss/atom-one-dark.scss';
hljs.initHighlightingOnLoad();

